module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACTSURBVHgBrdBRCoMwDAbgv62DPW0+yoaQo6yPO8V2ix1nu8nYSQyMwa4gYjURBUWUPvhDoE0/KInBSrKMaOfw1nNVw5sISH2LbSQEGsCuwE9j4HvILsDbJfj98d0E3AbIf+YJzM9USL30np/oKVWQ9Gdfbwu7x1goSWTRqQ6hUO6X2TCjuOMhLWVFD6l9EnBdgpoW/vpAcsAifn4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit-icon-3.png
// module id = 597
// module chunks = 0